<div id="alert" [ngClass]="show ? 'active' : 'inactive'">
    <div class="alert-inner">
        <div class="alert-box">
            <div
                class="alert-box-inner clearfix"
                [ngClass]="show ? 'alert-box-inner_active' : 'alert-box-inner_inactive'">
                <h2>{{ title }}</h2>
                @if (textIsArray) {
                    @for (tx of text; track tx) {
                        <div class="text-content">{{ tx }}</div>
                    }
                }
                @if (!textIsArray) {
                    <div class="text-content">{{ text }}</div>
                }
                <button mat-raised-button class="float-right" (click)="close()">Ok</button>
            </div>
        </div>
    </div>
</div>
